export default {"src":"/_next/static/media/location-icon.c405a320.svg","height":14,"width":14};